import CommonTable from "components/commonTable/CommonTable";
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getTrip } from "redux/actions/UserTrip";
import Loader from "components/loader/Loader";

function Invoice() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const status = ["completed", "cancelled"];
  // const location = useLocation();
  const navigate = useNavigate();
  const tableData = useSelector((state) => state?.userTrip?.userTrip?.data);
  const loader = useSelector((state) => state?.userTrip?.loading);
  let filterData = {
    id: "",
    page: page,
    status: status,
    pageSize: rowsPerPage,
    type:''
  };

  useEffect(() => {
    dispatch(getTrip(filterData));
  }, []);

  const onClickTableVendor = (data) => {
    let url = window.location.pathname.split("/")[1];
    if (url === "invoice") {
      // navigate(`/invoice/detail?id=${val.id}&&name=${val?.name}`)
      navigate(`/invoice/detail`, {
        state: {
          id: data?.id,
          status: data?.status,
          customer: data?.customerName,
          driver: data?.driverName,
          tripId: data?.tripId,
        },
      });
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getTrip({...filterData, page:newPage}))
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(getTrip({...filterData, page:0, pageSize:parseInt(event.target.value)}))
  };
  return (
    <div className="marginBlock35">
      <Grid>
        {loader ? (
          <Loader />
        ) : (
          <CommonTable
            data={tableData}
            onClickTableVendor={onClickTableVendor}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            isClickable={true}
          />
        )}
      </Grid>
    </div>
  );
}

export default Invoice;
